import { Dialog, DialogContent } from "@mui/material";
import React, { useEffect, useState } from "react";

const PrintDialog = ({ callbackPrintPreview, printDetails }) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });


  useEffect(() => {
    callbackPrintPreview(dialogDetails);
  }, [dialogDetails]);

 


  useEffect(() => {
    setTimeout(() => {
      var preview = document.getElementById("dialog_content");

      if (printDetails) {
        const iframe = document.createElement("iframe");

        iframe.src = printDetails;
        iframe.width = "100%";
        iframe.height = "850";
        iframe.frameBorder = "0";

        preview.innerHTML = "";
        preview.appendChild(iframe);

      }
    }, 500);
  }, [printDetails]);

  const handleClose = () => {
    setDialogDetails({
      open: false,
    });
  };

  const handlePrintClose = () => {
    window.addEventListener("beforeprint", () => {
      //console.log("before print");
    });

    window.addEventListener("afterprint", () => {
      // console.log("after print");
      handleClose();
    });
  };

  return (
    <Dialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <div id="dialog_content"></div>
    </Dialog>
  );
};

export default PrintDialog;
